import { useEffect, useRef } from 'react'
import { useDDPInspectorContext } from './DDPInspectorContext'

function useStableComponentInstanceId () {
  const ref = useRef(null)
  if (ref.current === null) {
    ref.current = `c-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
  }
  return ref.current
}

export default function useReportComponentAccessors ({
  inspectorId,
  component,
  label,
  accessors,
  dataAccessor
}) {
  const { isActive, setComponentAccessors, clearComponentAccessors } = useDDPInspectorContext()
  const componentInstanceId = useStableComponentInstanceId()

  // Stable dep for the accessors array contents without a deep-equal.
  const accessorsKey = JSON.stringify(accessors || [])

  useEffect(() => {
    if (!isActive || !inspectorId) return
    setComponentAccessors(inspectorId, componentInstanceId, {
      component,
      label: label || null,
      accessors: accessors || [],
      dataAccessor: dataAccessor || null
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps -- accessorsKey is the stable dep for accessors content
  }, [isActive, inspectorId, componentInstanceId, component, label, accessorsKey, dataAccessor, setComponentAccessors])

  useEffect(() => {
    if (!isActive || !inspectorId) return undefined
    return () => clearComponentAccessors(inspectorId, componentInstanceId)
  }, [isActive, inspectorId, componentInstanceId, clearComponentAccessors])
}
